import { render } from "./activateNumber.vue?vue&type=template&id=998ffd3a"
import script from "./activateNumber.vue?vue&type=script&lang=js"
export * from "./activateNumber.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BestPhone\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__